define('specific/mosaic/models/MosaicModel', [

], function() {

    var MosaicModel = Backbone.Model.extend({
        defaults: {
            type: "mosaicview",
            viewId: "",
            loadingInProgress: false,
            isReady: false,
            nbImagesToAdd: 12,
            nbImagesDisplayed: 0,
            nbImagesRequested: 0
        }
    });

    return MosaicModel;
});
